import React from 'react';
import { Dropdown } from 'antd';

export default ({ children, menu, ...rest }) => {
  return (
    <Dropdown overlay={menu} trigger={['click']} {...rest}>
      {children}
    </Dropdown>
  );
};
